<template>
    <div class="content-wrapper">
        <div class="col-12 mb-primary">
            <div class="card card-with-shadow border-0 h-100">
                <div class="card-header p-primary bg-transparent">
                    <h5 class="card-title d-inline-block mb-0">{{ $t('ticket') }}</h5>
                    <!-- <div class="float-right">
                           <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        {{ $t('agent') }}
                    </button>
                    </div> -->
                </div>
                <app-overlay-loader v-if="preloader"/>
                <div class="card-body">
                    <h3 class="text-info">Hello</h3>
                    <p class="text-muted font-size-90 mb-2">11/1/2021 4:20PM-Ali Khan-ali@gmail.com</p>
                    <div class="card card-with-search border-0 card-with-shadow mb-primary">
                        <div class="card-body stylebody">
                            <app-media-object 
                                :img-url="imgUrl"
                                :media-title="$t('media_title')"
                                :media-subtitle="$t('media_subtitle')"
                                :demo="'11/1/2021 4:20 PM'"/>
                        </div>
                    </div>
                    <form ref="form" data-url="/crud" class="mb-0" :class="{'loading-opacity': preloader}">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{ $t('reply') }}</label>
                                    <app-input type="textarea"
                                        row="10"
                                        v-model="inputs.about" />
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 action-buttons">
                            <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                                {{ $t('submit')}}
                            </button>
                            <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                                {{ $t('clear') }}
                            </button>
                        </div>
                    </form>
    
                </div>
            </div>
        </div>

        <adminticket-editmodal
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../core/mixins/form/FormMixin.js';

    export default {
        name: "FormGrid",
        mixins: [FormMixin],
        data() {
            return {
                isAddEditModalActive: false,
                preloader: false,
                inputs: {},
            }
        },
        methods: {

            openAddEditModal() {
            this.isAddEditModalActive = true;
        },
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.save(this.inputs);
            },

            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.inputs = {
                    gender: 'male',
                };
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
            openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            this.isAddEditModalActive = false;
        },
        }
    }
</script>